import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NewsPopupService, PopupStyle } from './news-popup.service';

@Component({
  selector: 'app-news-popup',
  templateUrl: './news-popup.component.html',
  styleUrls: ['./news-popup.component.scss']
})
export class NewsPopupComponent implements OnInit {
  showPopup = false;
  PopupStyle = PopupStyle; // Expose enum to template

  constructor(
    public newsPopupService: NewsPopupService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.showPopup = this.newsPopupService.shouldShowPopup();
  }

  getSafeHtml(key: string): SafeHtml {
    const translation = this.translate.instant(key);
    return this.sanitizer.bypassSecurityTrustHtml(translation);
  }

  onAcknowledge(): void {
    this.newsPopupService.markAsRead();
    this.showPopup = false;
    console.log('Popup marked as read. Storage key:', this.newsPopupService.getStorageKey());
    console.log('LocalStorage value:', localStorage.getItem(this.newsPopupService.getStorageKey()));
  }

  onClose(): void {
    this.showPopup = false;
  }

  onNavigate(): void {
    const config = this.newsPopupService.getConfig();
    if (config.leftButtonUrl) {
      window.open(config.leftButtonUrl, '_blank');
    }
    this.showPopup = false;
  }

  getLeftButtonText(): string {
    const config = this.newsPopupService.getConfig();
    return config.leftButtonText || 'news_popup.left_button';
  }

  getRightButtonText(): string {
    const config = this.newsPopupService.getConfig();
    return config.rightButtonText || 'news_popup.right_button';
  }
}
